let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ibBUd"), load("gcXcg"), load("jkoeR"), load("c6MKV"), load("anGwD")]).then(() => parcelRequire('1nPts'));